import {mollweideRaw} from "../mollweide.js";
import interrupt from "./index.js";

var lobes = [[ // northern hemisphere
  [[-180,   0], [-100,  90], [ -40,   0]],
  [[ -40,   0], [  30,  90], [ 180,   0]]
], [ // southern hemisphere
  [[-180,   0], [-160, -90], [-100,   0]],
  [[-100,   0], [ -60, -90], [ -20,   0]],
  [[ -20,   0], [  20, -90], [  80,   0]],
  [[  80,   0], [ 140, -90], [ 180,   0]]
]];

export default function() {
  return interrupt(mollweideRaw, lobes)
      .scale(169.529);
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-geo-projection/src/interrupted/mollweide.js
// module id = 720
// module chunks = 0